<div nz-row class="topbar" nzJustify="end">
    <div nz-col szSpan="4" class="pr-4">
        <app-notification-bell></app-notification-bell>
    </div>
    <div nz-col szSpan="4" class="pr-4">
        <nz-avatar nzIcon="user" nz-popover (nzPopoverVisibleChange)="userMenuVisibleChange($event)"
            [nzSrc]="sessionUser.profileImageUrl" [nzPopoverContent]="userMenu" nzPopoverPlacement="bottomRight">
        </nz-avatar>
        <ng-template #userMenu>
            <nz-list>
                <nz-list-header>
                    <span nz-typography><strong>{{sessionUser.name}}</strong></span><br />
                    <span nz-typography nzType="secondary">{{sessionUser.email}}</span>
                </nz-list-header>
                <nz-list-item>
                    <a (click)="profile()">
                        <i nz-icon nzType="user"></i>
                        Profile
                    </a>
                </nz-list-item>
                <nz-list-item>
                    <a (click)="logout()">
                        <i nz-icon nzType="logout"></i>
                        Log Out
                    </a>
                </nz-list-item>
            </nz-list>
        </ng-template>
    </div>
</div>